import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

/**
 * Utility privata per recuperare il token CSRF in sicurezza
 */
const getCsrfToken = () => {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.getAttribute('content') : ''
}

export const EventService = {

  async getEventBySlug (slug) {
    if (!slug) throw new Error('Slug mancante')

    try {
      const { data } = await apiClient.post('/auth.php', {
        json: 'model',
        event: slug,
        controllo: getCsrfToken()
      })

      if (!data) throw new Error('Evento non trovato')

      // Normalizzazione con valori di fallback
      return {
        template: data.template || 'modern-card',
        theme: data.theme || {},
        header: data.header || null,
        footer: data.footer || null,
        schema: data.fields || [],
        layout: data.layout || [],
        pages: data.pages || {}
      }
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Errore durante il caricamento dell\'evento')
    }
  },

  /**
   * Pulisce i dati e mappa le sessioni
   */
  preparePayload (formDataObj, schema) {
    const cleanData = {}
    const selectedSessions = []

    Object.keys(formDataObj).forEach(key => {
      const value = formDataObj[key]

      // Controllo validità: escludiamo null, undefined, stringhe vuote e array vuoti
      const hasValue = value !== '' && value !== null && value !== undefined &&
                       (Array.isArray(value) ? value.length > 0 : true)

      if (hasValue) {
        const fieldInfo = schema.find(f => f.name === key)
        const isSession = fieldInfo && ['session_radio', 'session_checkbox'].includes(fieldInfo.type)

        if (isSession) {
          // Flattening nel caso di session_checkbox (array in array)
          if (Array.isArray(value)) {
            selectedSessions.push(...value)
          } else {
            selectedSessions.push(value)
          }
        } else {
          // Usiamo la Label come chiave per il database/mail, fallback sul name
          const payloadKey = fieldInfo ? fieldInfo.label : key
          cleanData[payloadKey] = Array.isArray(value) ? value.join(', ') : value
        }
      }
    })

    if (selectedSessions.length > 0) {
      cleanData.sessions = selectedSessions
    }

    return cleanData
  },

  async registerUser (slug, payload) {
    try {
      const finalPayload = {
        controllo: getCsrfToken(),
        json: 'writepax',
        event_slug: slug,
        ...payload,
        registration_date: new Date().toISOString().slice(0, 19).replace('T', ' '), // Formato SQL friendly
        forced: 'RESTRICTED'
      }

      const response = await apiClient.post('/auth.php', finalPayload)
      return response.data
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Errore durante la registrazione')
    }
  },

  async invioMail (payload) {
    try {
      // Nota: Se invioconferma.php non legge JSON, usa URLSearchParams qui
      const finalPayload = {
        ...payload,
        controllo: getCsrfToken()
      }

      const response = await apiClient.post('/invioconferma.php', finalPayload)
      return response.data
    } catch (error) {
      console.error('Mail Error:', error)
      throw new Error('Impossibile inviare la mail di conferma')
    }
  }
}
